
import { CONFIG } from 'src/global-config';

import { SvgColor } from 'src/components/svg-color';



const icon = (name: string) => <SvgColor src={`${CONFIG.assetsDir}/assets/icons/icon_svg/${name}.svg`} sx={{ color: 'black' }} />;

const iconSX = (name: string, sx?: any) => <SvgColor src={`${CONFIG.assetsDir}/assets/icons/icon_svg/${name}.svg`} sx={sx} />;

const platformIconSX = (name: string, sx?: any) => <SvgColor src={`${CONFIG.assetsDir}/assets/icons/platforms//${name}.svg`} sx={sx} />;


export const CatchMomentsIcon = (name: string) => icon(name)
export const CatchMomentsIconSX = (name: string, sx?: any) => iconSX(name, sx)
export const CatchMomentPlatformIconSX = (name: string, sx?: any) => platformIconSX(name, sx)








